// assignByDomainMap is a map of domain to assignBy value.
export const assignByDomainMap: { [key: string]: string } = {
  primary: 'pax',
  secondary: 'dax',
  misc: 'tag',
  onboarding: 'patid',
  chaos: 'ip',
  cx_newface: 'pax',
  digital_goods: 'pax',
  'food-allocation-nss': 'tag',
  'food-eater': 'pax',
  'food-eater-sid': 'sid',
  'grab-express': 'pax',
  'grab-platform': 'pax',
  merchant: 'mex',
  'payments-rewards-pax': 'pax',
  topup: 'pax',
  'transport-allocation': 'pax',
  'transport-post-allocation': 'pax',
  'transport-pre-booking': 'pax',
  'trident-pax': 'id',
  'troy-merchant': 'sui',
  'help-center-pax': 'pax',
  'help-center-dax': 'dax',
  'merchant-user': 'meu',
  'merchant-store': 'mes',
  'poi-discovery': 'pax',
  'merchant-entity-country': 'mem',
  'merchant-helpcenter': 'mem',
  Web_Onboarding_Country: 'tag',
  web_onboarding_region: 'tag',
  'merchant-entity': 'mem',
  'mart-mex-country': 'mex',
  'mart-sid': 'sid',
  'safety-dax': 'dax',
  GrabCom: 'tag',
  'misc-flexible': 'tag',
  'merchant-flexible': 'mex',
  'merchant-user-country': 'meu',
  test_jem_geohash_domain: 'lgh',
  grab360: 'tag',
  phoenixagent: 'pid',
  grabber: 'pid',
  gxb: 'pid',
  gxs: 'pid',
  'misc-overlapping': 'tag',
  insurance: 'dax',
  'merchant-ltho': 'mex',
  'chope-merchant': 'mex',
};
